import React, { ReactElement } from 'react'

import { Color } from '../../../../../../enums/color'
import { TextProps } from '../../../../../Text'
import * as Styled from './styles'

interface TableCellContentProps extends TextProps {
  isSkeletonView?: boolean
  renderAsChildren?: boolean
  title?: string
}

export const TableCellContent = ({
  children,
  color,
  isSkeletonView,
  renderAsChildren,
  title,
  truncate,
  ...props
}: TableCellContentProps): ReactElement => {
  if (isSkeletonView) {
    return <Styled.TableSkeletonCellContent>{children}</Styled.TableSkeletonCellContent>
  }

  // Render children directly without the Text wrapper = support not only pure text content
  if (renderAsChildren) {
    return <div data-chromatic="ignore">{children}</div>
  }

  const textColor: Color | undefined = props.colorVariant ? undefined : color || Color.Grey950
  const titleText = title || (typeof children === 'string' ? children : undefined)

  return (
    <Styled.TableCellContent
      color={textColor}
      data-chromatic="ignore"
      title={truncate ? titleText : undefined}
      truncate={truncate}
      variant="bodyMD"
      {...props}
    >
      {children}
    </Styled.TableCellContent>
  )
}
